import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=1e4c035c&"
import script from "./AccountView.vue?vue&type=script&lang=ts&"
export * from "./AccountView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports